import React from "react";
import Editor from "@monaco-editor/react";

function CodeEditor({ height, value, language }) {
  const editorRef = React.useRef(null);

  function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;
  }

  return (
    <>
      <Editor
        height={height}
        language={language}
        value={value}
        onMount={handleEditorDidMount}
        theme="vs-dark"
        options={{
          autoIndent: true,
          formatOnPaste: true,
          formatOnType: true,
          minimap: {
            enabled: false,
          },
        }}
      />
      <br />
    </>
  );
}

export default CodeEditor;
